import v from "../../node_modules/classnames/index.js";
import { forwardRef as x, useState as E } from "react";
import "./UIInputFile2.js";
import { jsx as t, jsxs as i, Fragment as G } from "../../_virtual/jsx-runtime.js";
function L({
  color: a
}) {
  return /* @__PURE__ */ i("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: a,
    className: "bi bi-trash",
    viewBox: "0 0 16 16",
    children: [/* @__PURE__ */ t("path", {
      d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
    }), /* @__PURE__ */ t("path", {
      fillRule: "evenodd",
      d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
    })]
  });
}
function I({
  className: a,
  color: e
}) {
  return /* @__PURE__ */ t("svg", {
    className: a,
    version: "1.1",
    id: "L9",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 0 0",
    xmlSpace: "preserve",
    children: /* @__PURE__ */ t("path", {
      fill: e,
      d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50",
      children: /* @__PURE__ */ t("animateTransform", {
        attributeName: "transform",
        attributeType: "XML",
        type: "rotate",
        dur: "1s",
        from: "0 50 50",
        to: "360 50 50",
        repeatCount: "indefinite"
      })
    })
  });
}
const D = x(({
  uploadedFile: a,
  label: e,
  disabled: c,
  className: m,
  required: s,
  onBlur: p,
  name: h,
  hasError: o,
  size: S = "medium",
  deleteFile: g,
  uploadFile: N,
  onChange: d
}, u) => {
  const [r, n] = E(a ? "SUCCESS" : "MISSING");
  function C() {
    !a || (n("DELETING"), g(a).then(() => {
      n("MISSING"), d(void 0);
    }).catch(() => {
      n("SUCCESS");
    }));
  }
  function w(l) {
    !l.target.files || !l.target.files[0] || (n("SUBMITTING"), N(l.target.files[0]).then((T) => {
      n("SUCCESS"), d(T);
    }).catch(() => {
      n("FAILED");
    }));
  }
  function M() {
    return c ? "var(--grey-separation-color)" : o ? "var(--error-color)" : "var(--accent-color)";
  }
  const f = M();
  return r === "SUCCESS" || r === "DELETING" ? /* @__PURE__ */ t("div", {
    className: v("input-file shakeable", m),
    "data-size": S,
    "data-error": o,
    "data-disabled": c,
    children: /* @__PURE__ */ i("div", {
      className: "input-file__success",
      "data-error": o,
      children: [/* @__PURE__ */ t("a", {
        target: "__blank",
        href: a == null ? void 0 : a.url,
        children: a == null ? void 0 : a.name
      }), /* @__PURE__ */ i("button", {
        ref: u,
        type: "button",
        title: r === "SUCCESS" ? "Supprimer le fichier" : void 0,
        onClick: C,
        disabled: c || r === "DELETING",
        onBlur: p,
        children: [r === "SUCCESS" && /* @__PURE__ */ t(L, {
          color: f
        }), r === "DELETING" && /* @__PURE__ */ t(I, {
          className: "input-file__delete-loader",
          color: f
        })]
      })]
    })
  }) : /* @__PURE__ */ t("div", {
    className: v("input-file shakeable", m),
    "data-size": S,
    "data-error": o,
    "data-disabled": c,
    children: /* @__PURE__ */ i("div", {
      className: "input-file__pending",
      "data-status": r,
      "data-error": o,
      children: [/* @__PURE__ */ t("input", {
        disabled: c || r === "SUBMITTING",
        type: "file",
        ref: u,
        accept: "application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, image/png",
        name: h,
        id: h,
        onChange: w,
        onBlur: p
      }), /* @__PURE__ */ i("label", {
        htmlFor: h,
        children: [r === "MISSING" && /* @__PURE__ */ t("span", {
          children: s ? `${e} *` : e
        }), r === "SUBMITTING" && /* @__PURE__ */ i(G, {
          children: [/* @__PURE__ */ t(I, {
            className: "input-file__loader",
            color: f
          }), /* @__PURE__ */ t("span", {
            children: s ? `${e} *` : e
          })]
        }), r === "FAILED" && /* @__PURE__ */ t("span", {
          children: s ? `${e} *` : e
        })]
      })]
    })
  });
});
export {
  D as UIInputFile
};
//# sourceMappingURL=UIInputFile.js.map
